import * as React from "react";
import { forwardRef } from "react";
const SvgTags = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2 0v18l1.247-.929 5.8-4.353 5.8 4.353 1.24.929V0zm1.565 1.565h10.957v13.3L9.508 11.1l-.465-.342-.465.342-5.013 3.77Z", className: "s39240835b48fec453116168769153a0e__b" }));
const ForwardRef = forwardRef(SvgTags);
export { ForwardRef as ReactComponent };
